import { render, staticRenderFns } from "./SelectRamdomQuestion.vue?vue&type=template&id=23979036"
import script from "./SelectRamdomQuestion.vue?vue&type=script&lang=js"
export * from "./SelectRamdomQuestion.vue?vue&type=script&lang=js"
import style0 from "./SelectRamdomQuestion.vue?vue&type=style&index=0&id=23979036&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports